module.exports = __webpack_public_path__ + "static/media/p2.7989ef42.png";